import { writable } from "svelte/store";

export const customizeAvailableStore = writable(false);
